<div class="signImageConfig">
  <div #SignImageConfig>
    <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
  </div>
</div>

<mat-card *ngIf="isCheckAccessToContract" >
  <mat-card-header class="ml-5 mt-4">
    <mat-card-title>
      <span *ngIf="!isSignDigitalCertificate">{{ "title.signing_document" | translate }}</span>
      <span *ngIf="isSignDigitalCertificate">{{ "title.approving_document" | translate }}</span>
      <span *ngIf="document">{{document.code}} - {{document.name}}</span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true">
        <div class="steps-title">
          <!--    title của step-->
          <nz-steps [nzCurrent]="current" class="mb-3">
            <nz-step [nzTitle]="titleStep1">
              <ng-template #titleStep1>{{'enterprise_contract.image_signing.title_step_1' | translate}}</ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep2" *ngIf="isShowImage || !isSignDigitalCertificate">
              <ng-template #titleStep2>{{'enterprise_contract.image_signing.title_step_2' | translate}}</ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep3" *ngIf="isShowImage || !isSignDigitalCertificate">
              <ng-template #titleStep3>{{'enterprise_contract.image_signing.title_step_3' | translate}}</ng-template>
            </nz-step>
            <nz-step *ngIf="isShowEKYC && isShowImage || !isSignDigitalCertificate" [nzTitle]="titleStepEkyc">
              <ng-template
                  #titleStepEkyc>{{'enterprise_contract.image_signing.title_step_ekyc' | translate}}</ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep4">
              <ng-template #titleStep4>{{'enterprise_contract.image_signing.title_step_4' | translate}}</ng-template>
            </nz-step>
          </nz-steps>
          <!--end title của step-->

          <!--    nội dung, các phần này thay đổi-->
          <!--    tab chọn phương thức ký-->
          <div [hidden]="current !=0" class="max-width-content-step0">
            <div class="select-certificate">
              <div class="pb-3">
                <div class="col-12 mb-3">
                  <span
                    style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">
                    {{'digital_certificate_management.cbx_certificate_type.lbl_certificate_type' | translate}} </span>
                  <br />
                  <mat-radio-group #typeCertificateSelect id="typeCertificate" [(ngModel)]="typeSelectCertificate"
                    (change)="onChangeSelectCertificateType($event.value)" name="typeCertificate"
                    #typeCertificate="ngModel" required maxlength="100">
                    <mat-radio-button [value]="signMethod.SIGN_SIM_CA" class="pr-5">
                      {{'digital_certificate_management.cbx_certificate_type.cbx_sim_ca' | translate}}
                    </mat-radio-button>
                    <mat-radio-button [value]="signMethod.SIGN_USB_TOKEN" class="pr-5">
                      {{'digital_certificate_management.cbx_certificate_type.cbx_usb' | translate}}
                    </mat-radio-button>
                    <mat-radio-button [value]="signMethod.CLOUD_CA" class="pr-5">
                      {{'digital_certificate_management.cbx_certificate_type.cbx_cloud_ca' | translate}}
                    </mat-radio-button>
                    <mat-radio-button [value]="signMethod.SIGN_OTP" class="pr-5" *ngIf="allowOtp && isPersonal">
                      {{'digital_certificate_management.rd_certificate_type.cbx_otp' | translate}} {{ supportEkyc ? ("digital_certificate_management.rd_certificate_type.ekyc_support"
                        | translate) : '' }}
                    </mat-radio-button>
                    <!--                    <mat-radio-button [value]="signMethod.SIGN_NO_CERT" class="pr-5" *ngIf="signDataValidate.allowImage && ((signPosition && signPosition.length > 0 && signPosition[0].signType !== signPositionTypes.DIGITAL) || (signPosition && signPosition.length === 0))">-->
                    <!--                      {{'enterprise_contract.image_signing.new_tab.no_select_method' | translate}}-->
                    <!--                    </mat-radio-button>-->
                  </mat-radio-group>
                  <mat-error *ngIf="typeCertificate.invalid">
                    <span class="text-error">
                      {{'validation.lbl_validation_certificate_required' | translate}}
                    </span>
                  </mat-error>
                </div>
              </div>
            </div>

            <!-- *********_SimCA_********* -->
            <!-- số điện thoại -->
            <div class="row" *ngIf="typeSelectCertificate == 2">
              <div class="col-lg-4 col-sm-6 mt-3">
                <mat-form-field class="w-100">
                  <span matPrefix>+84 &nbsp;</span>
                  <input matInput (focusout)="simCaPhoneNumber=simCaPhoneNumber.trim()" type="text"
                    placeholder="{{'digital_certificate_management.lbl_phone' | translate}}" [pattern]="otpPhoneNumberPattern"
                    [(ngModel)]="simCaPhoneNumber" name="phoneNumber" #phoneNumber="ngModel" [maxlength]="maxLengthPhone" required>
                  <button mat-button *ngIf="simCaPhoneNumber" matSuffix mat-icon-button aria-label="Clear"
                    (click)="simCaPhoneNumber=null">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="phoneNumber.invalid">
                    <span class="text-error" *ngIf="phoneNumber?.errors?.required">
                      {{'validation.phone_number_re' | translate}}
                    </span>
                    <span class="text-error" *ngIf="phoneNumber?.errors?.pattern">
                      {{'validation.phone_format' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-8 col-sm-6 d-flex justify-content-start align-items-center">
                <button mat-raised-button type="button" [disabled]="!simCaPhoneNumber" (click)="getCertificateOfSimCA()"
                  color="primary">
                  <mat-icon class="mr-0">list</mat-icon>
                  {{'button.get_list' | translate}}
                </button>
              </div>
            </div>
            <!-- danh sách CTS-->
            <div class="row">
              <div class="col-12" *ngIf="typeSelectCertificate == 2 && listOfDataSimCa.length > 0">
                <nz-table [nzData]="listOfDataSimCa" #dynamicTable nzShowPagination="false" nzBordered="true">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{'enterprise_contract.table_headers.No' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                      <th class="desktop">{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                      <th>{{'headertable.tax_code_no' | translate}}</th>
                      <th class="desktop">{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template ngFor let-data [ngForOf]="dynamicTable.data">
                      <tr>
                        <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedCert($event,data)">
                        </td>
                        <td>{{data.STT}}</td>
                        <td>{{data.certificateName}}</td>
                        <td class="desktop">{{data.serialNumber}}</td>
                        <td>{{data.taxCode}}</td>
                        <td class="desktop">{{data.activeDate | dateformat}}</td>
                        <td>{{data.expireDate | dateformat}}</td>
                      </tr>
                    </ng-template>

                  </tbody>
                </nz-table>
              </div>
            </div>
            <!--*************** end SimCa **************-->

            <!-- *******_USB-Token_******* -->
            <!-- cách tải lên-->
            <div class="row">
              <div class="col-lg-8 col-sm-12">
                <div class="mb-2" style="top: 2rem;" *ngIf="typeSelectCertificate == 1">
                  <!-- tải lên từ Usb-Token -->
                  <ng-container *ngIf="typeSelectCertificate == 1" #uploadFromUsb>
                    <div>
                      <button mat-stroked-button color="primary" (click)="onGetCertificate()" type="button">
                        <mat-icon class="mr-0">usb</mat-icon>
                        {{'digital_certificate_management.upload_usb_token' | translate}}
                      </button>
                    </div>

                    <mat-error>
                      <span class="text-error" *ngIf="errorStatus != null">
                        <ng-container *ngIf="errorStatus != 'messages.not_initPlugin'; else errorInitPlugin">
                          {{ errorStatus | translate}}
                        </ng-container>
                        <ng-template #errorInitPlugin>
                          <!-- <ng-container>
                            {{ 'messages.not_initPlugin' | translate}}
                          </ng-container> -->
                          <!-- <br> -->
                          <ng-container>
                            {{ 'messages.check_input_software' | translate}}
                            <a target="_blank" href="{{getLinkDownload('WINDOWS')}}">
                              <span style="cursor: pointer;">{{ 'messages.win' |
                                translate}} </span>
                            </a>
                            <a target="_blank" href="{{getLinkDownload('MACOS')}}">
                              <span style="cursor: pointer;">{{ 'messages.mac' |
                                translate}} </span>
                            </a>
                            <a target="_blank" href="{{getLinkDownload('LINUX')}}">
                              <span style="cursor: pointer;">{{ 'messages.linux' |
                                translate}} </span>
                            </a>

                          </ng-container>
                          <ng-container>
                            {{ 'messages.check_input_usbtoken' | translate}}
                          </ng-container>
                          <br>
                        </ng-template>
                      </span>
                    </mat-error>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="typeSelectCertificate === 1 && this.usbTokenCertificate.issuedTo">
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.public_by' | translate}}"
                    [value]="usbTokenCertificate.issuedBy" id="cert_Issuer" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text"
                    placeholder="{{'digital_certificate_management.cer_subject_name' | translate}}"
                    [value]="usbTokenCertificate.issuedTo" id="cert_CN" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text"
                    placeholder="{{'digital_certificate_management.serial_number' | translate}}"
                    [value]="usbTokenCertificate.serialNumber" id="cert_SNB" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.mst_cmnd' | translate}}"
                    [value]="usbTokenCertificate.taxCode" id="taxcode" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.start_date' | translate}}"
                    [value]="usbTokenCertificate.activeDate | date: 'dd/MM/yyyy'" id="cert_ValidFrom" readonly>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="{{'digital_certificate_management.end_date' | translate}}"
                    [value]="usbTokenCertificate.expireDate | date: 'dd/MM/yyyy'" id="cert_ValidTo" readonly>
                </mat-form-field>
              </div>
              <div class="col-6 d-none">
                <mat-form-field class="w-100">
                  <input matInput type="text" placeholder="Raw Data" [value]="usbTokenCertificate.certRawdata"
                    id="cert_rawData" readonly>
                </mat-form-field>
              </div>
            </div>
            <!-- ********** end Usb Token ************-->

            <!-- ********* OTP ********* -->
            <div class="row" *ngIf="typeSelectCertificate == 3 && allowOtp && isPersonal" >
              <div class="col-lg-4 col-sm-6 mt-3">
                <mat-form-field class="w-100">
                  <span matPrefix>+84 &nbsp;</span>
                  <input matInput (focusout)="otpPhoneNumber=otpPhoneNumber.trim()" type="text"
                    placeholder="{{'digital_certificate_management.phone_number' | translate}}"
                    [(ngModel)]="otpPhoneNumber" name="otpPhone" #otpPhone="ngModel"
                    [maxlength]="otpPhoneNumberMaxLength" required [pattern]="otpPhoneNumberPattern"
                    (ngModelChange)="changePhone($event)">
                  <button mat-button *ngIf="otpPhoneNumber" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clear()">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="otpPhone.invalid">
                    <span class="text-error" *ngIf="otpPhone?.errors?.required">
                      {{'validation.phone_number_re' | translate}}
                    </span>
                    <span class="text-error" *ngIf="otpPhone?.errors?.pattern">
                      {{'validation.phone_format' | translate}}
                    </span>
                    <span class="text-error" *ngIf="otpPhone?.errors?.maxlength">
                      {{'lading_page.main.contact.validate_form.phone_otp_max_length' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!-- ********** end OTP ************-->

            <!-- ********* Ký ảnh ********* -->
            <div class="container"
              *ngIf="typeSelectCertificate === 6 && signDataValidate.allowImage && ((signPosition && signPosition.length > 0 && signPosition[0].signType !== signPositionTypes.DIGITAL) || (signPosition && signPosition.length === 0))">
              <mat-radio-button class="example-radio-button" checked="true">
              </mat-radio-button>
              {{'enterprise_contract.image_signing.new_tab.no_select_method_detail' | translate}}<br />
              <span
                class="registered-tab-title-note">{{'enterprise_contract.image_signing.new_tab.no_select_method_AN_detail'
                | translate}}</span>
            </div>
            <!-- ********** end Ký ảnh ************-->

            <!--            CLOUD CA-->
            <form>
              <div class="row" *ngIf="typeSelectCertificate == certificateType.CLOUD_CA">
                <div class="col-lg-4 col-sm-6 mt-3">
                  <div>
                    <mat-form-field>
                      <mat-label>{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</mat-label>
                      <mat-select #providerSelect (focusout)="(checkFocus = true)"
                        (focus)="commonService.openComboBox(checkFocus, providerSelect)" id="providerSelect"
                        [(ngModel)]="providerName"
                        (selectionChange)="checkFocus = false; onChangeSelectCertificate($event.value);"
                        #provider="ngModel" required name="providerSelect">
                        <mat-option *ngFor="let item of lstCloudCaProvider" [value]="item.name"
                          (click)="this.commonService.closeDropdownList(this.providerSelect)">
                          {{item.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-lg-4 col-sm-6 mt-3" *ngIf="typeSelectCertificate == certificateType.CLOUD_CA">
                  <mat-form-field class="w-100">
                    <input matInput type="text"
                      placeholder="{{'digital_certificate_management.lbl_account_cloudca' | translate}}"
                      (focusout)="cloudCaUsername = cloudCaUsername.trim()" [(ngModel)]="cloudCaUsername"
                      name="cloudCaUsername" #cloudCaUserId="ngModel" [ngClass]="{ 'is-invalid': cloudCaUserId.invalid }"
                      maxlength="200" required>
                    <button mat-button *ngIf="cloudCaUsername" type="button" matSuffix mat-icon-button aria-label="Clear"
                      (click)="cloudCaUsername=''">
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="cloudCaUserId.invalid">
                      <span class="text-error" *ngIf="cloudCaUserId?.errors?.required">
                        {{'validation.account_cloudca_required' | translate}}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 col-sm-6 d-flex justify-content-start align-items-center"
                  *ngIf="typeSelectCertificate == certificateType.CLOUD_CA">
                  <button mat-raised-button type="button" [disabled]="!cloudCaUsername || !providerName "
                    (click)="getCertificateCloudCa()" color="primary">
                    <mat-icon class="mr-0">list</mat-icon>
                    {{'button.get_list' | translate}}
                  </button>
                </div>
              </div>
            </form>

            <!--             danh sách CTS-->
            <div class="col-12"
              *ngIf="typeSelectCertificate == certificateType.CLOUD_CA && cloudCaDataSource.length > 0">
              <nz-table [nzData]="cloudCaDataSource" #dynamicTable2 nzShowPagination="false" nzBordered="true">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{'enterprise_contract.table_headers.No' | translate}}</th>
                    <th>{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                    <th>{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                    <th>{{'headertable.tax_code_no' | translate}}</th>
                    <th>{{'digital_certificate_management.cloud_ca_acc' | translate}}</th>
                    <th>{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
                    <th>{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template ngFor let-data [ngForOf]="dynamicTable2.data">
                    <tr>
                      <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedCloudCaCert($event,data)">
                      </td>
                      <td>{{data.STT}}</td>
                      <td>{{data.certificateName}}</td>
                      <td>{{data.serialNumber}}</td>
                      <td>{{data.taxCode}}</td>
                      <td>{{data.cloudCaUserId}}</td>
                      <td>{{data.activeDate | dateformat}}</td>
                      <td>{{data.expireDate | dateformat}}</td>
                    </tr>
                  </ng-template>

                </tbody>
              </nz-table>
            </div>
            <!--            ******** END CLOUD CA *********-->
            <!-- Tôi đã đọc, hiểu rõ, đồng ý và cam kết tuân thủ các Điều khoản -->
            <div class="row mt-2">
              <div class="col-12">
                <mat-checkbox [(ngModel)]="checkAgree" [ngModelOptions]="{standalone: true}" color="primary"></mat-checkbox>
                <span style="font-size:14px;"> {{'form.i_have_read' | translate}} <a tabindex="0"
                    routerLink="/registration-terms-information-sign-anonymous" target="_blank"> {{'form.rule' |
                    translate}} </a>
                </span>
              </div>
            </div>
          </div>
          <!--    end tab chọn phương thức ký-->

          <div class="steps-content max-width-content-step1" *ngIf="current==1 && (isShowImage || !isSignDigitalCertificate)">
            <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" (nzSelectChange)="nzSelectChange($event.index)" >
              <!-- Ảnh mặc định của hệ thống -->
              <nz-tab [nzTitle]="registeredImage"
                *ngIf="(selectedCert.typeCertificate !== signMethod.SIGN_NO_CERT) && (typeSelectCertificate !== signMethod.SIGN_NO_CERT)">
                <ng-template #registeredImage>
                  {{'enterprise_contract.image_signing.registered_tab.tab_system_default' | translate}}
                </ng-template>
                <div class="tab-content">
<!--                  <div *ngIf="selectedCert.imageUrl">-->
<!--                    <ng-container *ngIf="!onlyDigital">-->
<!--                      <img [src]="sanitize(selectedCert.imageUrl)" style="max-height: 300px; max-width: 600px;" />-->
<!--                    </ng-container>-->
<!--                    <ng-container *ngIf="onlyDigital">-->
<!--                      <div class="default-system-signature">-->
<!--                      </div>-->
<!--                    </ng-container>-->
<!--                    <span class="guiding-info">-->
<!--                      ({{'enterprise_contract.image_signing.registered_tab.no_image.only_digital' | translate}}) <br>-->
<!--                    </span>-->
<!--                  </div>-->
<!--                  <div *ngIf="!selectedCert.imageUrl">-->
<!--                    <div *ngIf="typeSelectCertificate === signMethod.SIGN_OTP" class="default-system-signature">-->
<!--                      <ng-container *ngIf="!onlyDigital">-->
<!--                        {{'enterprise_contract.image_signing.registered_tab.no_image.signed_by' | translate}}:-->
<!--                        {{enterpriseName}}-->
<!--                        <br />-->
<!--                        {{'enterprise_contract.image_signing.registered_tab.no_image.signed_phone' | translate}}:-->
<!--                        {{otpPhoneNumber}}-->
<!--                        <br />-->
<!--                        {{'enterprise_contract.image_signing.registered_tab.no_image.signed_date' | translate}}:-->
<!--                        {{currentDate | dateformat}}-->
<!--                        <br />-->
<!--                        <ng-container *ngIf="!isNotAttestedUser">-->
<!--                          {{'enterprise_contract.image_signing.registered_tab.no_image.verified_info' | translate}}-->
<!--                        </ng-container>-->
<!--                      </ng-container>-->
<!--                    </div>-->

<!--                    <div *ngIf="typeSelectCertificate !== signMethod.SIGN_OTP" class="default-system-signature">-->
<!--                      <ng-container *ngIf="!onlyDigital">-->
<!--                        {{'enterprise_contract.image_signing.registered_tab.no_image.signed_by' | translate}}:-->
<!--                        {{selectedCert.issuedTo || selectedCert.certificateName}}-->
<!--                        <br />-->
<!--                        {{'enterprise_contract.image_signing.registered_tab.no_image.signed_date' | translate}}:-->
<!--                        {{currentDate | dateformat}}-->
<!--                      </ng-container>-->
<!--                    </div>-->
<!--                    <span class="guiding-info">-->
<!--                      <ng-container *ngIf="onlyDigital">-->
<!--                        ({{'enterprise_contract.image_signing.registered_tab.no_image.only_digital' | translate}}) <br>-->
<!--                      </ng-container>-->
<!--                      {{'enterprise_contract.image_signing.registered_tab.no_image.guiding' | translate}} <br>-->
<!--                    </span>-->
<!--                  </div>-->

                  <app-image-sign-config [selectedCert]="selectedCert" [enterpriseName]="enterpriseName"
                                         [signConfig]="signConfig" [domRenderImage]="SignImageConfig" [signMethod]="signMethod"
                                         [scopeType]="scopeType">
                    <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
                  </app-image-sign-config>
                </div>
              </nz-tab>

              <!-- Tải ảnh mới lên -->
              <nz-tab [nzTitle]="uploadImage"
                *ngIf="!onlyDigital || selectedCert.typeCertificate === signMethod.SIGN_NO_CERT">
                <ng-template #uploadImage>{{'enterprise_contract.image_signing.new_tab.upload_image' | translate}}
                </ng-template>
                <div class="tab-content">
                  <div class="row">
                    <div class="clearfix nz-upload-clearfix">
                      <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'" [nzPreview]="handlePreview"
                        class="avatar-uploader" [nzCustomRequest]="dummyRequest" nzName="avatar"
                        nzListType="picture-card" [nzShowUploadList]="false" [nzBeforeUpload]="beforeUpload"
                        (nzChange)="handleChange($event)">
                        <ng-container *ngIf="!avatarUrl">
                          <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                          <div class="ant-upload-text">{{'form.select_upload' | translate}}</div>
                        </ng-container>
                        <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)"
                          style="max-height: 300px; max-width: 600px;" />
                      </nz-upload>
                    </div>
                  </div>

                  <span class="guiding-info">{{'title.upload_image_sign_guiding1' | translate}}
                    <br />{{'title.upload_image_sign_guiding2' | translate}}</span>
                </div>
              </nz-tab>

              <!-- Vẽ chữ ký - web -->
              <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()"
                *ngIf="(!onlyDigital || selectedCert.typeCertificate === signMethod.SIGN_NO_CERT)">
                <ng-template #drawSignature>{{'enterprise_contract.image_signing.new_tab.draw_signature' | translate}}
                </ng-template>

                <div class="steps-content">
                  <div class="tab-content">
                    <app-canvas [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"></app-canvas>
                  </div>
                </div>
              </nz-tab>

              <!-- TODO -->
              <!-- Vẽ chữ ký - mobile & tablet -->
              <!--              <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign(); showModalDrawSignature();" *ngIf="(!onlyDigital || selectedCert.typeCertificate === signMethod.SIGN_NO_CERT) && !deviceService.isDesktop()">-->
              <!--                <ng-template #drawSignature>{{'enterprise_contract.image_signing.new_tab.draw_signature' | translate}}-->
              <!--                </ng-template>-->
              <!--                <div class="steps-content">-->
              <!--                  <div class="tab-content text-center">-->
              <!--                    <nz-modal class="modal-centered" [(nzVisible)]="isVisibleModalDrawSignature" [nzTitle]="modalTitle" [nzContent]="modalContent" nzCentered-->
              <!--                    [nzWidth]="deviceService.isMobile() ? '97.9%' : '75.9%'" [nzStyle]="{'position': 'absolute', 'left': '50%', 'top': '50%', 'transform': 'translate(-50%, -50%)', 'animation-name': 'fadeIn', 'animation-duration': '0.4s'}">-->
              <!--                      <ng-template #modalTitle>{{'validation.create_draw_signature' | translate}}</ng-template>-->
              <!--                      <ng-template #modalContent>-->
              <!--                        <app-canvas></app-canvas>-->
              <!--                      </ng-template>-->
              <!--                      <div *nzModalFooter>-->
              <!--                        &lt;!&ndash; <button nz-button (click)="handleCancel()">cancel</button> &ndash;&gt;-->
              <!--                        <button nz-button [disabled]="disableBtnDeleteCanvas" (click)="handleOk()">ok</button>-->
              <!--                      </div>-->
              <!--                    </nz-modal>-->
              <!--                    <div [ngStyle]="{'border': '1px solid' , 'width': 'auto', 'margin': 'auto'}">-->
              <!--                      <img *ngIf="imageUrlPreview" [src]="sanitize(imageUrlPreview)"/>-->
              <!--                    </div>-->
              <!--                    <button class="mt-1" nz-button [nzType]="'primary'" (click)="showModalDrawSignature()">-->
              <!--                      <span>{{'validation.re_draw_signature' | translate}}</span>-->
              <!--                    </button>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </nz-tab>-->

            </nz-tabset>
          </div>

          <div class="steps-content" *ngIf="(current==2 || (current == 3 && !isShowEKYC)) && (isShowImage || !isSignDigitalCertificate)" class="max-width-content-step23"
            [class.landscape]="isViewLandscape">
            <div class="document scrollbar_scontract_xs">
              <p class="note mobile" *ngIf="isAllowSelectSignPosition"><i><span class="material-icons mr-1">warning</span>{{ "messages.click_to_select_sign_position" | translate }}</i></p>
              <div class="d-flex box-tab" id="box-center" style="width: 100%">
                <div class="px-2 py-2 tab" *ngFor="let file of document.mainContractAttachments; let i = index"
                  [class.active]="i === activeFile" (click)="changeFile(file.path, i)" [matTooltip]="file.fileName"
                  [class.error-tab]="checkFileNotHaveSign(file.id) && i !== activeFile"
                  [class.border-right]="i !== document.mainContractAttachments.length - 1 && i !== activeFile && i !== activeFile - 1">
                  <div class="name">
                    <i nz-icon [nzType]="'loading'" *ngIf="file.loading"></i>
                    {{ file.fileName }}
                  </div>
                </div>
              </div>
              <div>
                <ng-container *ngIf="pdfSrc != ''">
                  <!--
                  <pdf-viewer class="pdf-viewer" [src]="pdfSrc" (page-rendered)="pageRendered($event)"
                              [(page)]="pageCurrent"
                              [render-text]="true" [zoom]="zoomLevel" (text-layer-rendered)="textLayerRendered($event)"
                              (mousedown)="onMouseClickPdfViewer()">
                  </pdf-viewer>
                  -->
                  <ngx-extended-pdf-viewer [textLayer]="true" [src]="pdfSrc" (pageRendered)="pageRendered($event)"
                    (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" [(page)]="pageCurrent"
                    [showToolbar]="true" useBrowserLocale="true" height="calc(95vh - 180px - 4rem)" [handTool]="false"
                    [enablePrint]="false" [showDownloadButton]="false" [sidebarVisible]="true"
                    [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                    [showPropertiesButton]="true" [showUnverifiedSignatures]="true" [theme]="'dark'"
                    [language]="language" [zoomLevels]="[0.5,1,1.25, 1.5, 2, 3, 4]"
                    [showSidebarButton]="isShowSidebarButton">
                  </ngx-extended-pdf-viewer>
                </ng-container>
                <ng-template #notUpload>
                  <div *ngIf="pdfSrc" class="doc-wrapper view-document" [innerHTML]="pdfSrc | noSanitize"></div>
                </ng-template>
              </div>
            </div>
          </div>

          <ng-container *ngIf="!isReloadCamera">
            <div class="parent-document steps-content" [style.display]="isShowEKYC && (current == 3) ? 'block' : 'none'"
                 class="max-width-content-step23">
              <div class="document scrollbar_scontract_xs">
                <div>
                  <app-ekyc-camera
                    [isPassport]="isPassport">
                  </app-ekyc-camera>
                </div>
              </div>
            </div>
          </ng-container>
          <!--    end nội dung, các phần này thay đổi-->
        </div>
        <hr>

        <!-- Button web -->
        <div style="    right: 1px; background-color: white; left: 95px;" class="scontract-btn-dsk text-center mat-elevation-z0 py-2 w-100" id="navigation" #navigation>
          <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button" *ngIf="isSignDigitalCertificate"
            (click)="onClickBtnCancel(1)">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
          </button>
          <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button" *ngIf="!isSignDigitalCertificate"
                  (click)="onClickBtnCancel()">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
          </button>
          <!--      nút quay lại-->
          <button (click)="pre()" *ngIf="current > 0" mat-stroked-button class="mr-3" color="primary">
            <mat-icon class="mr-0">arrow_back</mat-icon>
            {{'button.back' | translate}}
          </button>
          <!--      nút tiếp tục -->
          <button (click)="next()" *ngIf="current < 2" mat-raised-button class="mr-3" color="primary"
            [disabled]="disableNextButton()">
            {{'button.next' | translate}}
            <mat-icon class="mr-0">arrow_forward</mat-icon>
          </button>
          <!--      đến trang ký -->
          <!-- <button (click)="gotoSignPage()" *ngIf="current === 2" mat-stroked-button class="mr-3" color="primary">
            <mat-icon class="mr-0">pin_drop</mat-icon>
            {{'enterprise_contract.buttons.goto_signing_page' | translate}}
          </button> -->
          <button mat-stroked-button color="primary" class="mr-3" (click)="onStamped()"
            *ngIf="current === 2 && isAllowSelectSignPosition">
            <mat-icon class="mr-0">replay</mat-icon>
            {{'enterprise_contract.buttons.re_select_position' | translate}}
          </button>
          <button mat-raised-button color="primary" class="mr-3" (click)="checkTimestampMoney()" *ngIf="current === 2 || current === 3">
            <mat-icon class="mr-0">gesture</mat-icon>
            {{'enterprise_contract.buttons.sign' | translate}}
          </button>
        </div>

        <!-- Button mobile -->
        <div class="scontract-btn-mobile bg-white text-center shadow-lg rounded">
          <ngx-slick-carousel #btnView class="carousel" #slickModal="slick-carousel" [config]="slideButtonConfig">
            <div ngxSlickItem class="flex-fill slide" (click)="onClickBtnCancel(1)" *ngIf="isSignDigitalCertificate">
              <mat-icon>cancel</mat-icon>
              <h6 class="mb-0">{{'button.cancel' | translate}}</h6>
            </div>
            <div ngxSlickItem class="flex-fill slide" (click)="onClickBtnCancel()" *ngIf="!isSignDigitalCertificate">
              <mat-icon>cancel</mat-icon>
              <h6 class="mb-0">{{'button.cancel' | translate}}</h6>
            </div>
            <div ngxSlickItem class="flex-fill slide" (click)="pre()" *ngIf="current > 0">
              <mat-icon>arrow_back</mat-icon>
              <h6 class="mb-0">{{'button.back' | translate}}</h6>
            </div>
            <div ngxSlickItem class="flex-fill slide" (click)="next()" *ngIf="current == 0 && !isDisableNextButton">
              <mat-icon>arrow_forward</mat-icon>
              <h6 class="mb-0">{{'button.next' | translate}}</h6>
            </div>
            <div ngxSlickItem class="flex-fill slide" (click)="next()" *ngIf="current < 2 && current > 0">
              <mat-icon>arrow_forward</mat-icon>
              <h6 class="mb-0">{{'button.next' | translate}}</h6>
            </div>
            <!-- <div ngxSlickItem class="flex-fill slide" (click)="gotoSignPage()" *ngIf="current === 2">
              <mat-icon>pin_drop</mat-icon>
              <h6 class="mb-0">{{'enterprise_contract.buttons.goto_signing_page' | translate}}</h6>
            </div> -->
            <div ngxSlickItem class="flex-fill slide" (click)="onStamped()"
              *ngIf="current === 2 && isAllowSelectSignPosition">
              <mat-icon>replay</mat-icon>
              <h6 class="mb-0">{{'enterprise_contract.buttons.re_select_position' | translate}}</h6>
            </div>
            <div ngxSlickItem class="flex-fill slide" (click)="checkTimestampMoney()" *ngIf="current === 2 || current === 3">
              <mat-icon>gesture</mat-icon>
              <h6 class="mb-0">{{'enterprise_contract.buttons.sign' | translate}}</h6>
            </div>
          </ngx-slick-carousel>
        </div>

      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>


<!-- <app-page-not-found-no-access *ngIf="!isCheckAccessToContract" (backToPrevPage)="backToPrePage()">
</app-page-not-found-no-access> -->

<ng-template #ImageConfigView>
  <ng-container *ngIf="!signConfig?.signatureImage.enabled;else noSignatureImage">
    <div style="padding: 20px;" [style.width]="'1184px'" [style.height]="'528px'" class="image-config_view__content align-items-center d-flex flex-row">
      <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
    </div>
  </ng-container>
  <ng-template #noSignatureImage>
    <ng-container  [ngSwitch]="signConfig?.signaturePosition?.value">
      <div style="padding: 20px;" *ngSwitchCase="'left'" [style.width]="'1464px'" [style.height]="'528px'" class="image-config_view__content d-flex align-items-center justify-content-center flex-row">
        <div class="d-flex justify-content-center align-items-center" [style.flex] = "getNumber(signConfig.signatureRatio.value)[0]">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center" [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div style="padding: 20px;" *ngSwitchCase="'right'" [style.width]="'1464px'" [style.height]="'528px'" class="image-config_view__content d-flex align-items-center justify-content-center flex-row-reverse">
        <div class="d-flex justify-content-center align-items-center" [style.flex] = "getNumber(signConfig.signatureRatio.value)[0]">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div style="padding: 20px;" style="padding-left: 24px;" class="d-flex justify-content-start align-items-center" [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div style="padding: 20px;" *ngSwitchCase="'top'" [style.width]="'1184px'" [style.height]="'932px'" class="image-config_view__content d-flex align-items-center justify-content-center flex-column">
        <div class="d-flex justify-content-center align-items-center" [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div class="d-flex justify-content-start align-items-center"[style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div style="padding: 20px;" *ngSwitchCase="'bottom'" [style.width]="'1184px'" [style.height]="'932px'" class="image-config_view__content d-flex align-items-center justify-content-center flex-column-reverse">
        <div class="d-flex justify-content-center align-items-center" [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div class="d-flex justify-content-start align-items-center" [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #SignatureViewContent>
  <ng-container *ngIf="signConfig.signatureImageBase64.value.split(',')[1]">
    <ng-container *ngIf="signConfig?.signaturePosition?.value === 'left' || signConfig?.signaturePosition?.value === 'right'">
      <img
      [style.max-height]="'508px'"
      [style.max-width]="346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 'px'"
      [src]="signConfig.signatureImageBase64.value">
    </ng-container>
    <ng-container *ngIf="signConfig?.signaturePosition?.value === 'top' || signConfig?.signaturePosition?.value === 'bottom'">
      <img
      [style.max-width]="'1164px'"
      [style.height]="imageSignConfig?.widthImageSignature < 346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) ? (217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px' : 'auto'"
      [style.max-height]="(217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px'"
      [src]="signConfig.signatureImageBase64.value">
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #ImageViewContent>
  <div id="imageConfigContainer" class="imageConfigContainer">
    <ng-container *ngFor="let key of getConfigKeyList()">
      <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
    </ng-container>

    <ng-container *ngIf="signConfig.greenTick.enabled">
      <div class="green-tick"
           [style.top]="signConfig.signaturePosition.value ? 18 * 4 * (+getNumber(signConfig.signatureRatio.value)[1] / 100) + 'px' : '72px'"
           [style.left]="signConfig.signaturePosition.value ? 46 * 4 * (+getNumber(signConfig.signatureRatio.value)[1] / 100) + 'px' : '184px'"
      >
      <svg width="316" height="232" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z" fill="#52C41A"/>
      </svg>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
    <div [style.font-style]="signConfig.fontStyle.value || ''" [style.font-weight]="signConfig.fontWeight.value || ''" [style.fontFamily]="signConfig.fontFamily.value || 'Times-Roman'" *ngIf="showConfig(data)" class="view-content-item">
      <ng-container *ngIf="data == 'signatureImage' || data == 'isDraw'; else displayColon"></ng-container>
      <ng-template #displayColon>
        <div style="word-break: break-word;" [style.textAlign]="signConfig.contentPosition.value">
          {{signConfig[data].label | translate}}: {{signConfig[data].value}}
        </div>
      </ng-template>

      <!--        <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" class="label"></div>&nbsp;-->

      <!--      <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" align="start" style="word-break: break-word; white-space: pre-wrap;">-->
      <!--        <ng-container>-->
      <!--          {{signConfigClone[data].value}}-->
      <!--        </ng-container>-->
      <!--      </div>-->
    </div>
</ng-template>


<!-- <ng-template #ImageConfig>
  <div class="image-config_view__content">
    <div id="imageConfigContainer">
      <ng-container *ngFor="let key of getConfigKeyList()">
        <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
      </ng-container>

      <div *ngIf="signConfig.greenTick.enabled" class="green-tick">
        <svg width="158" height="116" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z" fill="#52C41A"/>
        </svg>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
  <div *ngIf="showConfig(data)" class="view-content-item" style="font-family: Roboto">
    <div class="label">{{signConfig[data].label | translate}}:</div>&nbsp;
    <div align="start" style="word-break: break-word">
      <ng-container>
        {{signConfig[data].value}}
      </ng-container>
    </div>
  </div>
</ng-template> -->
